import { useState, useEffect } from "react";
import { APIGet } from "../../API/APIRequest";

export function RSSFeed(props) {

    const { lossAversionMessage, fid } = props;
    const [feedItems, setFeedItems] = useState([]);
    const rssStyle = lossAversionMessage?.messageStyle;
    const itemsDisplayed = lossAversionMessage?.itemsDisplayed;

    useEffect(() => {

        if (!fid) {
            return;
        }

        const fetchRss = async () => {
            try {
               
                const response = await APIGet({
                    controller: "rss",
                    action: "getfeed",
                    identifier: fid
                });

                setFeedItems(response?.data?.items || []);
            }
            catch (error) {
                console.log(error);
            }
        };

        fetchRss();

    }, [fid]);


    return (
        <div>
            <div className="item-wrapper">
                {feedItems.slice(0, itemsDisplayed).map((item, i) => (
                    <li className="list-style-none" key={i + item.guid}>
                        <a href={item.link}>

                            <span className="rss-item">
                                {(rssStyle === "HeadlineImageAndDate" || rssStyle === "HeadlineAndImage") &&
                                    item.enclosure?.link && (<img
                                        src={item.enclosure.link}
                                        alt={item.title}
                                        className="rss-thumbnail"
                                    />)}

                                {/* {(rssStyle==="HeadlineImageAndDate") && <span className="rss-date"></span>} */}

                                <h5>{item.title}</h5>

                            </span>
                        </a>
                    </li>
                ))}
            </div>
        </div>

    );
}
